import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'lin-page-not-found',
  templateUrl: './page-not-found.component.html',
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
